import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ROUTE_MAINTENANCE } from '../app.constants';
import { MaintenanceService } from '../service/maintenance/maintenance.service';
import Keycloak from 'keycloak-js';
import { Maintenance } from '../model/maintenance-http.model';

async function checkMaintenanceMode() {
  const maintenanceService = inject(MaintenanceService);
  const keycloak = inject(Keycloak);

  const maintenanceModeResponse: Maintenance = await lastValueFrom(maintenanceService.fetchMaintenanceMode()).catch(
    () => ({ enabled: false }) as Maintenance,
  );
  const isMaintenanceModeEnabled = maintenanceModeResponse.enabled;

  if (isMaintenanceModeEnabled) {
    await keycloak.logout({
      redirectUri: window.location.origin + '/' + ROUTE_MAINTENANCE,
    });
    return false;
  }
  return true;
}

export const maintenanceGuard: CanActivateFn = checkMaintenanceMode;
